export interface TimeZone {
  id: string;
  displayName: string;
  genericName: string;
  abbr: string;
  utcOffset: number;
}

export const getDefaultTimeZone = (): TimeZone => {
  return {
    id: "",
    displayName: "",
    genericName: "",
    abbr: "",
    utcOffset: 0
  };
};
